import React from 'react';
import { useIntl } from 'react-intl';
import { Button } from 'reactstrap';

import { openIntercomNewMessage } from '../../../helpers';

import VideoShowcase from '../../VideoShowcase';

const OnboardingNeedHelp = () => {
  const intl = useIntl();

  return (
    <div className="onboarding-card">
      <div className="onboarding-card-header">
        {intl.formatMessage({ defaultMessage: 'Need Help?' })}
      </div>
      <div className="onboarding-card-video">
        <VideoShowcase
          thumbnail="https://i.vimeocdn.com/video/2137583199-c7e0c6ae86f05a606ac2436e9f0ffa19d6c4f9b5aecf45e3f13bec5768ab2e65-d?mw=800&mh=450"
          video="https://player.vimeo.com/video/834207096?h=5a4bce0dde&badge=0&byline=0&title=0"
          title={intl.formatMessage({ defaultMessage: 'Stockpress platform walkthrough' })}
        />
      </div>
      <div className="onboarding-card-links">
        <Button color="link" tag="a" href="https://help.stockpress.co/" target="_blank">
          <i className="fal fa-arrow-up-right-from-square fa-fw" />
          <span>{intl.formatMessage({ defaultMessage: 'Visit our help center' })}</span>
        </Button>
        <Button color="link" tag="a" href="https://stockpress.co/demo" target="_blank">
          <i className="fal fa-calendar fa-fw" />
          <span>{intl.formatMessage({ defaultMessage: 'Book an onboarding call' })}</span>
        </Button>
        <Button color="link" onClick={openIntercomNewMessage}>
          <i className="fal fa-message fa-fw" />
          <span>{intl.formatMessage({ defaultMessage: 'Start a chat' })}</span>
        </Button>
      </div>
    </div>
  );
};

export default OnboardingNeedHelp;
